import { Injectable } from '@angular/core';
import { AppConfigService } from './appConfigService';
import { HttpClient } from '@angular/common/http';
import { AssignmentCodeStatusRequestModel, AssignmentCodeStatusResponseModel, FinanceServiceResponseModel } from '../model/Workspace/FinanceServiceResponseModel';
import { Observable } from 'rxjs';
import { PracticeEngineJobUpdateResponseModel } from '../model/PracticeEngineServiceModel';
import { User } from '../model/User';

@Injectable({
  providedIn: 'root'
})
export class PEService {
  FinanceIntegrationAPIEndPoint: string;
  APIEndPoint: string;
  userName: string;
  fullName: string;
  userEmail: string;
  userInfo: User = new User();
  constructor(private environment: AppConfigService, private http: HttpClient) {
    this.FinanceIntegrationAPIEndPoint = environment.config.DATA.API_END_POINT.FINANCE_INTEGRATION_API_URL;
    this.APIEndPoint = this.environment.config.DATA.API_END_POINT.API_URL;
    this.initializeUserDetails();
  }

  initializeUserDetails() {
      let nameJSON = localStorage.getItem('currentUser');
      this.userInfo = JSON.parse(nameJSON);
      // console.log(nameJSON, nameJSON != null);
      if (nameJSON != null) {
        this.userName = this.userInfo.userName;
        this.fullName = this.userInfo.loggedInUserFullName;
        this.userEmail = this.userInfo.loggedInUserEmail;
  
      }
    }

  PostCodeStatusFinance(assignmentCodeStatusRequestModel: AssignmentCodeStatusRequestModel): Observable<FinanceServiceResponseModel<AssignmentCodeStatusResponseModel>> {
    return this.http.post<FinanceServiceResponseModel<AssignmentCodeStatusResponseModel>>(this.FinanceIntegrationAPIEndPoint + '/api/assignments/codeStatus', assignmentCodeStatusRequestModel);
  }

  UpdatePracticeEngineJobData(engagementId: number, request: any) : Observable<PracticeEngineJobUpdateResponseModel>{
    request.lastModifiedBy = this.userName
    return this.http.post<PracticeEngineJobUpdateResponseModel>(`${this.APIEndPoint}/Engagement/UpdatePracticeEngineJobData/${engagementId}`, request);
  }
}
